<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('attendanceEventsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="attendance-event-workspace"
         [class.attendance-event-workspace--loading]="isLoading">
      <mat-card class="attendance-event-panel attendance-event-panel--detail"
                [class.attendance-event-panel--view]="isViewMode">
        <div class="attendance-event-panel__header">
          <div class="attendance-event-panel__heading">
            <span class="attendance-event-panel__eyebrow">{{ 'attendanceEventsCatalog.breadcrumb' | translate }}</span>
            <h3>{{ detailTitle }}</h3>
            <p>{{ detailDescription }}</p>
          </div>
          <div class="attendance-event-panel__actions">
            @if (selectedEvent && isViewMode) {
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-danger"
                    *appCanAccess="deleteAccess"
                    (click)="deleteSelected()">
              <mat-icon>delete_outline</mat-icon>
              {{ 'common.delete' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="goBackToList()">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.back' | translate }}
            </button>
            }
            @if (isCreateMode) {
            <button mat-flat-button
                    type="button"
                    class="btn-tone-primary"
                    (click)="save()"
                    [disabled]="isSaving || !canSave">
              <mat-icon>save</mat-icon>
              {{ 'common.create' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="cancelEdit()"
                    [disabled]="isSaving">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.cancel' | translate }}
            </button>
            }
          </div>
        </div>

        <div class="attendance-event-panel__body">
          @if (isCreateMode) {
          <div class="attendance-event-editor">
            <div class="card attendance-event-editor__section mb-0">
              <div class="card-body">

                <div class="attendance-event-editor__form-grid">
                  @if (isCreateMode) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field attendance-event-editor__field--full">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.employee' | translate }}</mat-label>
                    <input matInput
                           #employeeTrigger="matAutocompleteTrigger"
                           [ngModel]="employeeSearchText"
                           (ngModelChange)="onEmployeeSearchInput($event)"
                           [matAutocomplete]="employeeAutocomplete"
                           [placeholder]="'attendanceEventsCatalog.filters.employeePlaceholder' | translate"
                           autocomplete="off"
                           [disabled]="isSaving"
                           (focus)="employeeTrigger.openPanel()"
                           (click)="employeeTrigger.openPanel()">
                    <button mat-icon-button
                            matSuffix
                            type="button"
                            tabindex="-1"
                            [disabled]="isSaving"
                            (click)="employeeTrigger.openPanel()">
                      <mat-icon>search</mat-icon>
                    </button>
                    <mat-autocomplete #employeeAutocomplete="matAutocomplete"
                                      [displayWith]="displayEmployeeOption"
                                      (optionSelected)="onEmployeeSelected($event)">
                      @for (employee of filteredEmployees; track employee.employeeId) {
                      <mat-option [value]="employee">{{ employee.fullName || employee.employeeNumber }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                  }

                  @if (!isCreateMode) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.source' | translate }}</mat-label>
                    <mat-select [(ngModel)]="form.source"
                                [disabled]="isSaving">
                      @for (source of sourceOptions; track source) {
                      <mat-option [value]="source">{{ ('attendanceEventsCatalog.sources.' + source) | translate }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  }

                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.eventType' | translate }}</mat-label>
                    <mat-select [(ngModel)]="form.eventType"
                                [disabled]="isSaving">
                      @for (type of eventTypeOptions; track type) {
                      <mat-option [value]="type">{{ ('attendanceEventsCatalog.eventTypes.' + type) | translate }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <div #eventAtPickerShell
                       class="attendance-event-editor__field attendance-event-editor__field--full attendance-event-datetime"
                       (click)="$event.stopPropagation()">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                    class="attendance-event-datetime__trigger">
                      <mat-label>{{ 'attendanceEventsCatalog.fields.eventAt' | translate }}</mat-label>
                      <input matInput
                             [ngModel]="eventAtInput"
                             (ngModelChange)="onEventAtInputChange($event)"
                             [placeholder]="'dd/mm/aaaa hh:mm'"
                             autocomplete="off"
                             [disabled]="isSaving"
                             (focus)="openEventAtPicker()"
                             (click)="openEventAtPicker()">
                      <button mat-icon-button
                              matSuffix
                              type="button"
                              tabindex="-1"
                              [disabled]="isSaving"
                              (click)="openEventAtPicker(); $event.stopPropagation()">
                        <mat-icon>event</mat-icon>
                      </button>
                    </mat-form-field>

                    @if (isEventAtPickerOpen && !isSaving) {
                    <div class="attendance-event-datetime__panel">
                      <div class="attendance-event-datetime__header">
                        <button type="button"
                                class="attendance-event-datetime__nav-btn"
                                (click)="changeEventAtMonth(-1)">
                          <mat-icon>chevron_left</mat-icon>
                        </button>
                        <strong>{{ eventAtMonthLabel }}</strong>
                        <button type="button"
                                class="attendance-event-datetime__nav-btn"
                                (click)="changeEventAtMonth(1)">
                          <mat-icon>chevron_right</mat-icon>
                        </button>
                      </div>

                      <div class="attendance-event-datetime__weekdays">
                        @for (weekday of eventAtWeekdayLabels; track weekday) {
                        <span>{{ weekday }}</span>
                        }
                      </div>

                      <div class="attendance-event-datetime__days">
                        @for (day of eventAtCalendarDays; track day.date.toISOString()) {
                        <button type="button"
                                class="attendance-event-datetime__day"
                                [class.attendance-event-datetime__day--muted]="!day.currentMonth"
                                [class.attendance-event-datetime__day--selected]="day.selected"
                                [class.attendance-event-datetime__day--today]="day.today"
                                (click)="selectEventAtDate(day.date)">
                          {{ day.label }}
                        </button>
                        }
                      </div>

                      <div class="attendance-event-datetime__footer">
                        <div class="attendance-event-datetime__time-box">
                          <mat-icon>schedule</mat-icon>
                          <input type="time"
                                 [ngModel]="eventAtTimeValue"
                                 (ngModelChange)="onEventAtTimeChange($event)">
                        </div>

                        <button type="button"
                                class="attendance-event-datetime__today-btn"
                                (click)="goToTodayEventAt()">
                          {{ 'common.today' | translate }}
                        </button>
                      </div>
                    </div>
                    }
                  </div>

                  @if (!isCreateMode) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.timezone' | translate }}</mat-label>
                    <input matInput
                           [(ngModel)]="form.timezone"
                           [disabled]="isSaving">
                  </mat-form-field>
                  }

                  @if (!isCreateMode && hasMeaningfulValue(form.deviceId)) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.deviceId' | translate }}</mat-label>
                    <input matInput
                           [(ngModel)]="form.deviceId"
                           [disabled]="isSaving">
                  </mat-form-field>
                  }

                  @if (!isCreateMode && hasMeaningfulValue(form.deviceVersion)) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.deviceVersion' | translate }}</mat-label>
                    <input matInput
                           [(ngModel)]="form.deviceVersion"
                           [disabled]="isSaving">
                  </mat-form-field>
                  }

                  @if (!isCreateMode && hasMeaningfulValue(form.lat)) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.lat' | translate }}</mat-label>
                    <input matInput
                           type="number"
                           step="0.000001"
                           [(ngModel)]="form.lat"
                           [disabled]="isSaving">
                  </mat-form-field>
                  }

                  @if (!isCreateMode && hasMeaningfulValue(form.lng)) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.lng' | translate }}</mat-label>
                    <input matInput
                           type="number"
                           step="0.000001"
                           [(ngModel)]="form.lng"
                           [disabled]="isSaving">
                  </mat-form-field>
                  }

                  @if (!isCreateMode && hasMeaningfulValue(form.accuracy)) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.accuracy' | translate }}</mat-label>
                    <input matInput
                           type="number"
                           step="1"
                           [(ngModel)]="form.accuracy"
                           [disabled]="isSaving">
                  </mat-form-field>
                  }

                  @if (!isCreateMode && hasMeaningfulValue(form.faceValidationStatus)) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.faceValidationStatus' | translate }}</mat-label>
                    <mat-select [(ngModel)]="form.faceValidationStatus"
                                [disabled]="isSaving">
                      <mat-option [value]="''">-</mat-option>
                      @for (faceStatus of faceValidationStatusOptions; track faceStatus) {
                      <mat-option [value]="faceStatus">{{ ('attendanceEventsCatalog.faceStatuses.' + faceStatus) | translate }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  }

                  @if (!isCreateMode) {
                  @if (hasMeaningfulValue(form.normalizedEventType)) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.normalizedEventType' | translate }}</mat-label>
                    <mat-select [(ngModel)]="form.normalizedEventType"
                                [disabled]="isSaving">
                      <mat-option [value]="''">-</mat-option>
                      @for (type of eventTypeOptions; track type) {
                      <mat-option [value]="type">{{ ('attendanceEventsCatalog.eventTypes.' + type) | translate }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  }

                  @if (hasMeaningfulValue(form.status)) {
                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.status' | translate }}</mat-label>
                    <mat-select [(ngModel)]="form.status"
                                [disabled]="isSaving">
                      @for (status of statusOptions; track status) {
                      <mat-option [value]="status">{{ ('attendanceEventsCatalog.statuses.' + status) | translate }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  }

                  <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                  class="attendance-event-editor__field attendance-event-editor__field--full">
                    <mat-label>{{ 'attendanceEventsCatalog.fields.isActive' | translate }}</mat-label>
                    <mat-select [(ngModel)]="form.isActive"
                                [disabled]="isSaving">
                      <mat-option [value]="true">{{ 'common.status.active' | translate }}</mat-option>
                      <mat-option [value]="false">{{ 'common.status.inactive' | translate }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  }

                  @if (!isCreateMode && hasMeaningfulValue(form.rawPayloadText)) {
                  <div class="attendance-event-editor__field attendance-event-editor__field--full pt-0 mt-0">
                    <details class="attendance-event-payload attendance-event-payload--editor">
                      <summary>
                        <span>{{ 'attendanceEventsCatalog.fields.rawPayload' | translate }}</span>
                        <mat-icon>expand_more</mat-icon>
                      </summary>
                      <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                      class="attendance-event-editor__payload-field">
                        <textarea matInput
                                  rows="8"
                                  [(ngModel)]="form.rawPayloadText"
                                  [disabled]="isSaving"></textarea>
                      </mat-form-field>
                    </details>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          } @else if (selectedEvent; as event) {
          <div class="attendance-event-detail attendance-event-detail--redesigned">
            <section class="attendance-event-hero">
              <div class="attendance-event-hero__employee">
                <div class="attendance-event-avatar">{{ employeeInitials }}</div>
                <div>
                  <span>{{ 'attendanceEventsCatalog.fields.employee' | translate }}</span>
                  <strong>{{ event.employeeLabel }}</strong>
                  <small>#{{ event.employeeNumber }}</small>
                </div>
              </div>

              <div class="attendance-event-hero__facts">
                <div class="attendance-event-hero-fact">
                  <mat-icon>{{ eventSourceIcon }}</mat-icon>
                  <div><span>{{ 'attendanceEventsCatalog.fields.source' | translate }}</span><strong>{{ event.sourceLabel }}</strong></div>
                </div>
                <div class="attendance-event-hero-fact attendance-event-hero-fact--event">
                  <mat-icon>{{ eventTypeIcon }}</mat-icon>
                  <div><span>{{ 'attendanceEventsCatalog.fields.eventType' | translate }}</span><strong>{{ event.eventTypeLabel }}</strong></div>
                </div>
                <div class="attendance-event-hero-fact">
                  <mat-icon>calendar_month</mat-icon>
                  <div><span>{{ 'attendanceEventsCatalog.fields.eventAt' | translate }}</span><strong>{{ eventDateLabel }}</strong><small>{{ eventTimeLabel }}</small></div>
                </div>
              </div>

              <div class="attendance-event-hero__statuses">
                <div class="attendance-event-status-card attendance-event-status-card--success">
                  <mat-icon>check</mat-icon>
                  <div><strong>{{ event.statusLabel }}</strong><span>Evento procesado</span></div>
                </div>
                @if (event.faceValidationStatus) {
                <div class="attendance-event-status-card" [class.attendance-event-status-card--success]="isFaceValidationSuccessful">
                  <mat-icon>face</mat-icon>
                  <div><strong>{{ event.faceValidationStatusLabel }}</strong><span>{{ 'attendanceEventsCatalog.fields.faceValidationStatus' | translate }}</span></div>
                </div>
                }
                @if (hasEventLocation) {
                <div class="attendance-event-status-card attendance-event-status-card--location">
                  <mat-icon>location_on</mat-icon>
                  <div><strong>Ubicación registrada</strong><span>{{ eventAccuracyLabel }}</span></div>
                </div>
                }
              </div>
            </section>

            <div class="attendance-event-overview-grid" [class.attendance-event-overview-grid--without-map]="!hasEventLocation">
              <section class="attendance-event-info-card">
                <div class="attendance-event-card-heading"><mat-icon>event_note</mat-icon><h4>Información del evento</h4></div>
                <div class="attendance-event-detail-list">
                  <div><span>{{ 'attendanceEventsCatalog.fields.eventType' | translate }}</span><strong class="attendance-event-value-pill">{{ event.eventTypeLabel }}</strong></div>
                  <div><span>{{ 'attendanceEventsCatalog.fields.normalizedEventType' | translate }}</span><strong class="attendance-event-value-pill">{{ event.normalizedEventTypeLabel }}</strong></div>
                  <div><span>Fecha</span><strong>{{ eventDateLabel }}</strong></div>
                  <div><span>Hora</span><strong>{{ eventTimeLabel }}</strong></div>
                  <div><span>{{ 'attendanceEventsCatalog.fields.source' | translate }}</span><strong>{{ event.sourceLabel }}</strong></div>
                  <div><span>{{ 'attendanceEventsCatalog.fields.timezone' | translate }}</span><strong>{{ event.timezone }}</strong></div>
                </div>
              </section>

              <section class="attendance-event-info-card">
                <div class="attendance-event-card-heading"><mat-icon>verified_user</mat-icon><h4>Validación y dispositivo</h4></div>
                <div class="attendance-event-detail-list">
                  <div><span>{{ 'attendanceEventsCatalog.fields.status' | translate }}</span><strong class="attendance-event-inline-status"><mat-icon>check_circle</mat-icon>{{ event.statusLabel }}</strong></div>
                  <div><span>{{ 'attendanceEventsCatalog.fields.faceValidationStatus' | translate }}</span><strong [class.attendance-event-inline-status]="isFaceValidationSuccessful">{{ event.faceValidationStatusLabel }}</strong></div>
                  <div><span>{{ 'attendanceEventsCatalog.fields.deviceId' | translate }}</span><strong>{{ event.deviceId || '-' }}</strong></div>
                  <div><span>{{ 'attendanceEventsCatalog.fields.deviceVersion' | translate }}</span><strong>{{ event.deviceVersion || '-' }}</strong></div>
                  <div><span>{{ 'attendanceEventsCatalog.fields.accuracy' | translate }} GPS</span><strong>{{ eventAccuracyLabel }}</strong></div>
                  <div><span>{{ 'attendanceEventsCatalog.fields.location' | translate }}</span><strong>{{ hasEventLocation ? 'Coordenadas disponibles' : '-' }}</strong></div>
                </div>
              </section>

              @if (hasEventLocation) {
              <section class="attendance-event-map-card">
                <div class="attendance-event-card-heading attendance-event-map-card__heading">
                  <div><mat-icon>location_on</mat-icon><h4>{{ 'attendanceEventsCatalog.location.title' | translate }}</h4></div>
                  @if (googleMapsUrl; as mapsUrl) {
                  <a mat-stroked-button class="attendance-event-map-link" [href]="mapsUrl" target="_blank" rel="noopener noreferrer">
                    <img src="assets/icon/maps.svg" alt="" aria-hidden="true">
                    <span>Ver en Google Maps</span>
                  </a>
                  }
                </div>
                <div class="attendance-event-related-tracking__map-shell attendance-event-map-card__map-shell">
                  <div class="attendance-event-related-tracking__map" #relatedTrackingMap></div>
                  <aside class="attendance-event-map-summary">
                    <strong>Ubicación registrada</strong>
                    <span><mat-icon>my_location</mat-icon>{{ eventCoordinatesLabel }}</span>
                    <span><mat-icon>gps_fixed</mat-icon>{{ 'attendanceEventsCatalog.fields.accuracy' | translate }}: {{ eventAccuracyLabel }}</span>
                    @if (relatedTrackingPointsCount > 0) {
                    <span><mat-icon>timeline</mat-icon>{{ relatedTrackingPointsCount }} puntos relacionados</span>
                    }
                  </aside>
                  @if (isRelatedTrackingLoading) {
                  <div class="attendance-event-related-tracking__overlay"><mat-icon>timeline</mat-icon><strong>{{ 'attendanceEventsCatalog.relatedTracking.loading' | translate }}</strong></div>
                  }
                </div>
                <div class="attendance-event-map-legend"><span><i></i>Marcaje registrado</span><span><i class="attendance-event-map-legend__route"></i>Seguimiento relacionado</span></div>
              </section>
              }
            </div>

            <details class="attendance-event-technical">
              <summary>
                <div class="attendance-event-card-heading"><mat-icon>storage</mat-icon><div><h4>Detalles técnicos y payload</h4><p>Información técnica adicional del evento.</p></div></div>
                <mat-icon class="attendance-event-technical__chevron">expand_more</mat-icon>
              </summary>
              <div class="attendance-event-technical__grid" [class.attendance-event-technical__grid--without-payload]="!hasRawPayload">
                <section class="attendance-event-technical-card">
                  <h5><mat-icon>memory</mat-icon>Información técnica</h5>
                  <div class="attendance-event-detail-list attendance-event-detail-list--compact">
                    <div><span>{{ 'attendanceEventsCatalog.fields.deviceId' | translate }}</span><strong>{{ event.deviceId || '-' }}</strong></div>
                    <div><span>{{ 'attendanceEventsCatalog.fields.deviceVersion' | translate }}</span><strong>{{ event.deviceVersion || '-' }}</strong></div>
                    <div><span>{{ 'attendanceEventsCatalog.fields.source' | translate }}</span><strong>{{ event.sourceLabel }}</strong></div>
                    <div><span>{{ 'attendanceEventsCatalog.fields.status' | translate }}</span><strong>{{ event.statusLabel }}</strong></div>
                  </div>
                </section>
                <section class="attendance-event-technical-card">
                  <h5><mat-icon>pin_drop</mat-icon>Coordenadas</h5>
                  <div class="attendance-event-detail-list attendance-event-detail-list--compact">
                    <div><span>{{ 'attendanceEventsCatalog.fields.lat' | translate }}</span><strong>{{ event.lat ?? '-' }}</strong></div>
                    <div><span>{{ 'attendanceEventsCatalog.fields.lng' | translate }}</span><strong>{{ event.lng ?? '-' }}</strong></div>
                    <div><span>{{ 'attendanceEventsCatalog.fields.accuracy' | translate }}</span><strong>{{ eventAccuracyLabel }}</strong></div>
                    <div><span>{{ 'attendanceEventsCatalog.fields.timezone' | translate }}</span><strong>{{ event.timezone }}</strong></div>
                  </div>
                </section>
                @if (hasRawPayload) {
                <section class="attendance-event-technical-card attendance-event-technical-card--payload">
                  <h5><mat-icon>code</mat-icon>{{ 'attendanceEventsCatalog.fields.rawPayload' | translate }}</h5>
                  <pre>{{ event.rawPayload | json }}</pre>
                </section>
                }
              </div>
            </details>
          </div>
          } @else {
          <div class="attendance-event-empty">
            <mat-icon>fact_check</mat-icon>
            <h4>{{ 'attendanceEventsCatalog.emptyEditorTitle' | translate }}</h4>
            <p>{{ 'attendanceEventsCatalog.emptyEditorDescription' | translate }}</p>
          </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
      <app-loading-state class="attendance-event-loading"
                         [message]="'attendanceEventsCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
